import { render } from "./HomePage.vue?vue&type=template&id=3bf38a5a&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=3bf38a5a&lang=css"
import "./HomePage.vue?vue&type=style&index=1&id=3bf38a5a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf38a5a"]])

export default __exports__